import { ColumnHorizontalAlignment, ColumnLateralAlignment } from "building-types/columns/columnTypesEnum";
import { assertUnreachable } from "common/utils/assertUnreachable";
import type { AABB2 } from "geom/aabb2Types";

export function resolveAlignmentsToShifts(
  aabbObject: AABB2,
  horizontalAlignment: ColumnHorizontalAlignment,
  lateralAlignment: ColumnLateralAlignment,
) {
  const width = aabbObject.maxX - aabbObject.minX;
  const height = aabbObject.maxY - aabbObject.minY;

  let horizontalShift: number = 0;

  switch (horizontalAlignment) {
    case ColumnHorizontalAlignment.LEFT:
      horizontalShift = -0.5 * width;
      break;
    case ColumnHorizontalAlignment.CENTER:
      horizontalShift = 0;
      break;
    case ColumnHorizontalAlignment.RIGHT:
      horizontalShift = 0.5 * width;
      break;
    default:
      assertUnreachable(horizontalAlignment);
  }

  let lateralShift: number = 0;

  switch (lateralAlignment) {
    case ColumnLateralAlignment.FRONT:
      lateralShift = -0.5 * height;
      break;
    case ColumnLateralAlignment.CENTER:
      lateralShift = 0;
      break;
    case ColumnLateralAlignment.BACK:
      lateralShift = 0.5 * height;
      break;
    default:
      assertUnreachable(lateralAlignment);
  }
  return { width, height, horizontalShift, lateralShift };
}
